import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import OfferCard, {
  CARD_MAX_WIDTH
} from '#client/components/OpenAccountApplication/components/Steps/ValidationMessage/components/OfferCard';

/**
 * The Mercury and Bank of America partner cards, side by side on desktop and stacked on mobile.
 * @param {object} props Component props
 * @param {Array<object>} props.cards Cards from `useBankingOptionCards`
 * @returns {import('react').ReactElement} The card row
 */
export default function BankingOptionCards({ cards }) {
  return (
    <Stack
      sx={{
        flexDirection: { xs: 'column', md: 'row' },
        gap: 1,
        alignItems: 'stretch',
        justifyContent: 'center'
      }}
    >
      {cards.map(({ id, ...card }) => (
        <Box
          data-testid={id}
          key={id}
          sx={{ flex: 1, minWidth: 0, maxWidth: { md: CARD_MAX_WIDTH } }}
        >
          <OfferCard {...card} />
        </Box>
      ))}
    </Stack>
  );
}

BankingOptionCards.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired
};
